
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch, } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading } from "../../reducers/uiReducer";

import TransactionHistory from "./TransactionHistory";
import AccountSelection from "./AccountSelection";

import moment from 'moment';
import { throttle } from 'lodash';

const MaintenancePay: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const formattedDate = moment.unix(hardmoneyData.feeDueDate).format("M/D/YYYY");

    const currentTimeSec = Math.floor(Date.now() / 1000); // current time in seconds
    const isOverDue = currentTimeSec >= hardmoneyData.feeDueDate;
    
    const secondsUntilDue = hardmoneyData.feeDueDate - currentTimeSec;
    const isWithinThreeDays = secondsUntilDue <= 259200 && secondsUntilDue > 0;
    
    const fetchHouseData = useCallback(
        throttle(async (selectedAccount: string) => {
            dispatch(SET_isLoading(true));
            try {
                const res: HardMoneyState = await socketRequest("PayMaintenance", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    payAccount: selectedAccount,
                }, hardmoneyData);
                if (res) {
                    dispatch(SET_HOUSEDATA(res));
                } else {
                    throw new Error("Invalid house data received.");
                }
            } catch (err) {
                console.error("Error purchase house data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch]
    );
    
    const handlePay = (e: React.MouseEvent) => {
        e.preventDefault();

        fetchHouseData(uiData.selectedAccount);
    };


    return (
        
            
                    <div
                        style={{
                            width: "100%",
                            //height: "50%",
                            //backgroundColor: "red",
                            border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                            borderRadius: "0.5vh",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            flexDirection: "column",
                            boxSizing: "border-box",
                            padding: "2vh",
                            fontSize: "1.5vh",
                        }}
                    >
                        <div
                            style={{
                                height: "100%",
                                width: "100%",
                                //backgroundColor: "purple",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                boxSizing: "border-box",
                                //paddingRight: "5vh",
                            }}
                        >
                            <div
                                style={{
                                    boxSizing: "border-box",
                                    height: "auto",
                                    width: "auto",
                                    //backgroundColor: "yellow",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "left",
                                    flexDirection: "column",
                                    //gap: "0.5vh",
                                    gap: 0,
                                    paddingBottom: "1vh",
                                    marginRight: "auto",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "auto",
                                        width: "100%",
                                        color: "gray",
                                        fontWeight: "bold",
                                    }}
                                >
                                    DUE DATE
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "auto",
                                        width: "100%",
                                        fontSize: "4vh",
                                        fontWeight: 'bold',
                                        //backgroundColor: "red",
                                    }}
                                >
                                    {formattedDate}
                                </div>
                            </div>
                            <div
                                style={{
                                    boxSizing: "border-box",
                                    height: "auto",
                                    width: "auto",
                                    //backgroundColor: "yellow",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "left",
                                    flexDirection: "column",
                                    //gap: "0.5vh",
                                    paddingBottom: "1vh",
                                    marginRight: "auto",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "auto",
                                        width: "100%",
                                        color: "gray",
                                        fontWeight: "bold",
                                    }}
                                >
                                    AMOUNT
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "auto",
                                        width: "100%",
                                        fontSize: "4vh",
                                        fontWeight: 'bold',
                                        //backgroundColor: "red",
                                    }}
                                >
                                    ${hardmoneyData.propertyFee.toLocaleString("en-US")}
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                height: "50%",
                                width: "100%",
                                //backgroundColor: "gray",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                //sboxSizing: "border-box",
                                padding: "1vh 1vh",
                            }}
                        >
                            {(isWithinThreeDays || isOverDue) && (
                                <div
                                    onClick={e => handlePay(e)}
                                    style={{
                                        boxSizing: "border-box",
                                        height: "100%",
                                        //width: "50%",
                                        backgroundColor: `rgba(${uiData.schemeColor}, 0.2)`,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "left",
                                        flexDirection: "column",
                                        borderRadius: "1vh",
                                        border: `0.2vh solid rgb(${uiData.schemeColor})`,
                                        padding: "0.75vh 1vh",
                                        marginRight: "auto",
                                        cursor: "pointer",
                                    }}
                                >
                                    Pay with selected account
                                </div>
                            )}
                            {isOverDue && (
                                <div
                                    style={{
                                        boxSizing: "border-box",
                                        height: "100%",
                                        //width: "50%",
                                        backgroundColor: `rgba(252, 74, 3, 0.2)`,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "left",
                                        flexDirection: "column",
                                        borderRadius: "1vh",
                                        border: `0.2vh solid rgb(252, 74, 3)`,
                                        padding: "0.75vh 1vh",
                                        marginRight: "auto",
                                        cursor: "pointer",
                                    }}
                                >
                                    Overdue Balance!
                                </div>
                            )}
                        </div>
                    </div>
                   
      
    );
};

export default MaintenancePay;
